<script setup>
const props = defineProps({
    showCounts: {
        type: Boolean,
        default: () => false
    }
})

const tags = defineModel('tags')
const { data, error, pending } = await useAsyncData('all-tags', () => $fetch('/api/v1/post-tags'));

const check = (tag) => {
    if (tags.value.has(tag)) {
        tags.value.delete(tag)   
    } else {
        tags.value.add(tag)
    }
}

</script>
<template>
    <div class='post-tags'>
        <ul class="tags">
            <li v-for="tag in data" :key="tag.tag">
                <label class="tag" :aria-checked="tags.has(tag.tag)" :for="`tag-${tag.slug}`" tabindex="0" @keyup.space="check(tag.name)">
                    <input type="checkbox" :id="`tag-${tag.slug}`" name="tags" :value="tag.tag" v-model="tags" :aria-label="`Filter posts with the tag ${tag.name}`" />
                    <span class="tag-name">{{ tag.name }} <span class="count" v-if="showCounts">{{ tag.count }}</span></span>
                </label>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    .post-tags {

        .tags {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        
        .tags li {
            margin-bottom: 0.75rem;
            padding: 0;
            font-size: calc(16 / var(--base-fs) * 1rem);
            font-weight: 300;
            line-height: 1.25rem;
            letter-spacing: 0.0175rem;

            @media (min-width: 768px) {
                font-size: calc(14 / var(--base-fs) * 1rem);
            }
        }

        .tags li label {
            user-select: none;
            display: flex;
            align-items: center;
            gap: 0.75rem;
            cursor: pointer;

            .tag-name {
                    width: 100%;
                    display: flex;
                    .count {
                        margin-left: auto;
                        opacity: 0.25;
                    }
            }

            input[type="checkbox"] {
                border: 1px solid var(--teal);
                box-sizing: border-box;
                width: 12px;
                height: 12px;
                padding: 0;
                border: 1px solid var(--teal-light);
                appearance: none;
                background-color: transparent;
                cursor: pointer;
                outline: none;
                transition: outline 0.1s;

                &:checked {
                    background-size: cover;
                    padding: 2px;
                }

                &:focus {
                    outline: 1px solid var(--orange-light);
                }

                &:not(:disabled):checked {
                    border-color: var(--orange-dark);
                    background-image: url('~/assets/img/check.svg');
                }
            }
        }
    }    
</style>